// Custom.js — ordercrabs.com

// === 1. Scroll-lock override ===
(function () {
  var style = document.createElement("style");
  style.textContent = [
    "body, html { position: static !important; top: auto !important; overflow: visible !important; overflow-x: clip !important; overflow-y: visible !important; }",
    "body.\\!overflow-clip, html.\\!overflow-clip { overflow: visible !important; overflow-y: visible !important; }",
    "body.pr-\\[--scrollbar-width\\] { padding-right: 0 !important; }",
  ].join("\n");
  document.head.appendChild(style);
})();

